import React from 'react';
import Table from 'react-bootstrap/Table';
import ActiviteEntente from '../../../../../../common/src/entities/activite-entente.entity';
interface DynamicTableActivitesProps {
    data: ActiviteEntente[],
    title: string;
}
const DynamicTableActivites: React.FC<DynamicTableActivitesProps> = ({ data, title }) => {
    return (
        <div>
            <h5>{title}</h5>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Nom</th>
                        <th>Thématique</th>
                        <th>Produit</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((activiteEntente) => (
                        <tr key={activiteEntente.id}>
                            <td>{activiteEntente.activite.name}</td>
                            <td>{activiteEntente.thematique?.name}</td>
                            <td>{activiteEntente.activiteEntenteProduit?.map((produit) => (
                                <div key={produit.id}>{produit.produit?.name}</div>
                            ))}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );

}
export default DynamicTableActivites;